import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CONTROL } from '../../../../components';
import { generateBaseItems } from '../../../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var OsNameItem = {
  Ubuntu: 'Ubuntu',
  OracleLinux: 'Oracle Linux'
};
var osNameItems = [{
  value: OsNameItem.Ubuntu,
  label: 'Ubuntu'
}, {
  value: OsNameItem.OracleLinux,
  label: 'Oracle Linux'
}];
var osNameToOsVersionMap = _defineProperty(_defineProperty({}, OsNameItem.OracleLinux, ['9.3']), OsNameItem.Ubuntu, ['20.04', '22.04', '24.04']);
var NameFlavourItem = {
  IntelBroadwellSSD: '2 x Intel Broadwell EP Xeon E5-2699 v4 22 ядра 2.2ГГц; RAM: 64ГБ; SSD: 800ГБ SATA',
  IntelBroadwellHDD: '2 x Intel Broadwell EP Xeon E5-2699 v4 22 ядра 2.2ГГц; RAM: 64ГБ; HDD: 2 x 900ГБ SAS',
  IntelHaswellRam64: '2 x Intel Haswell EP Xeon E5-2690 v3 12 ядер 2.6ГГц; RAM: 64ГБ; HDD: 4 x 2ТБ SATA',
  IntelHaswellRam128: '2 x Intel Haswell EP Xeon E5-2690 v3 12 ядер 2.6ГГц; RAM: 128ГБ; HDD: 4 x 2ТБ SATA',
  IntelSkylake: '2 x Intel Skylake-SP Xeon Gold 6161 22 ядра 2.2ГГц; RAM: 64ГБ; SSD: 4 x 800ГБ SAS'
};
var nameFlavourItems = [{
  value: NameFlavourItem.IntelBroadwellSSD,
  label: '2 x Intel Broadwell EP Xeon E5-2699 v4',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["22 \u044F\u0434\u0440\u0430 2.2 \u0413\u0413\u0446 ", /*#__PURE__*/_jsx("br", {}), "RAM 64 \u0413\u0411 ", /*#__PURE__*/_jsx("br", {}), "800 \u0413\u0411 SSD SATA"]
  })
}, {
  value: NameFlavourItem.IntelBroadwellHDD,
  label: '2 x Intel Broadwell EP Xeon E5-2699 v4',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["22 \u044F\u0434\u0440\u0430 2.2 \u0413\u0413\u0446 ", /*#__PURE__*/_jsx("br", {}), "RAM 64 \u0413\u0411 ", /*#__PURE__*/_jsx("br", {}), " 2 x 900 \u0413\u0411 HDD SAS"]
  })
}, {
  value: NameFlavourItem.IntelHaswellRam64,
  label: '2 x Intel Haswell EP Xeon E5-2690 v3',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["12 \u044F\u0434\u0435\u0440 2.6 \u0413\u0413\u0446 ", /*#__PURE__*/_jsx("br", {}), "RAM 64 \u0413\u0411 ", /*#__PURE__*/_jsx("br", {}), "4 x 2 \u0422\u0411 HDD SATA"]
  })
}, {
  value: NameFlavourItem.IntelHaswellRam128,
  label: '2 x Intel Haswell EP Xeon E5-2690 v3',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["12 \u044F\u0434\u0435\u0440 2.6 \u0413\u0413\u0446 ", /*#__PURE__*/_jsx("br", {}), "RAM 128 \u0413\u0411 ", /*#__PURE__*/_jsx("br", {}), "4 x 2 \u0422\u0411 HDD SATA"]
  })
}, {
  value: NameFlavourItem.IntelSkylake,
  label: '2 x Intel Skylake-SP Xeon Gold 6161',
  description: /*#__PURE__*/_jsxs(_Fragment, {
    children: ["22 \u044F\u0434\u0440\u0430 2.2 \u0413\u0413\u0446 ", /*#__PURE__*/_jsx("br", {}), "RAM 64 \u0413\u0411 ", /*#__PURE__*/_jsx("br", {}), "4 x 800 \u0413\u0411 SSD SAS"]
  })
}];
export var EVOLUTION_BARE_METAL_FORM_CONFIG = {
  ui: [['osName', 'osVersion'], 'nameFlavour', ['networkDisk'], 'eipAlert', 'eip'],
  controls: {
    osName: {
      type: CONTROL.SelectSingle,
      accessorKey: 'osName',
      defaultValue: OsNameItem.Ubuntu,
      items: osNameItems,
      decoratorProps: {
        label: 'Операционная система'
      }
    },
    osVersion: {
      type: CONTROL.SelectSingle,
      accessorKey: 'osVersion',
      defaultValue: '20.04',
      items: generateBaseItems(osNameToOsVersionMap[OsNameItem.Ubuntu]),
      decoratorProps: {
        label: 'Версия операционной системы'
      },
      watchedControls: {
        osName: 'osName'
      },
      relateFn: function relateFn(_ref) {
        var osName = _ref.osName;
        var items = osNameToOsVersionMap[osName];
        if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
          return {
            items: generateBaseItems(items)
          };
        }
      }
    },
    nameFlavour: {
      type: CONTROL.ToggleCards,
      accessorKey: 'nameFlavour',
      defaultValue: NameFlavourItem.IntelBroadwellSSD,
      items: nameFlavourItems,
      decoratorProps: {
        label: 'Конфигурация'
      }
    },
    networkDisk: {
      type: CONTROL.Array,
      max: 1,
      accessorKey: 'networkDisk',
      defaultValue: [],
      addText: 'Добавить диск',
      ui: ['disk'],
      controls: {
        disk: {
          type: CONTROL.Stepper,
          decoratorProps: {
            label: 'Сетевой диск',
            labelTooltip: 'Дополнительное хранилище, которое можно подключить к серверу',
            labelTooltipPlacement: 'right'
          },
          accessorKey: 'diskSpace',
          defaultValue: 1,
          uiProps: {
            min: 1,
            max: 4096,
            postfix: 'ГБ'
          }
        }
      }
    },
    eipAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: 'При подключении сервиса публичный IP-адрес назначается по умолчанию'
      },
      accessorKey: 'public-ip'
    },
    eip: {
      type: CONTROL.Toggle,
      accessorKey: 'bindingPublickIpAddress',
      defaultValue: true,
      decoratorProps: {
        label: 'Аренда публичного IP'
      },
      uiProps: {
        disabled: true
      }
    }
  }
};